<template>
  <v-layout column>
    <v-layout v-if="anyOtherState" justify-center class="my-4" fill-height>
      <v-progress-circular color="primary" v-if="loading" indeterminate class="align-center"/>
      <v-layout row v-else-if="error" fill-height justify-center align-center>
        <h3 v-if="!placeholder" class="text-center">{{ placeholderMessage }}</h3>
        <request-response-placeholder v-else showPlaceholder :message="placeholderMessage"/>
      </v-layout>
      <h3 v-else-if="empty" class="text-center">Não há registros.</h3>
    </v-layout>
    <slot v-else />
  </v-layout>
</template>

<script>
import RequestResponsePlaceholder from '@/components/RequestResponsePlaceholder'
import { message } from '@/mixins'

/**
 * @vuese
 * Componente para controle da listagem em forms
 */
export default {
  name: 'LoadFormHandler',

  components: {
    RequestResponsePlaceholder
  },

  props: {
    promise: {
      type: Function,
      required: true
    },

    value: {
      type: [Array, Object],
      required: true
    },

    placeholder: {
      type: Boolean,
      default: false
    },

    placeholderMessage: {
      type: String,
      default: 'Houve um erro ao carregar os dados'
    }
  },

  data: () => ({
    loading: true,
    error: false,
    empty: false
  }),

  mixins: [message],

  mounted () {
    this.promise()
      .then(this.handleResponse)
      .catch(this.handleError)
      .finally(this.handleFinally)
  },

  computed: {
    responseData: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    },

    anyOtherState () {
      return this.loading || this.error || this.empty
    }
  },

  methods: {
    handleResponse ({ data }) {
      if ((Array.isArray(data) && data.length) || Object.keys(data).length) {
        this.responseData = data
      } else {
        this.empty = true
      }
    },

    handleError (error) {
      this.$emit('error', error)
      this.handleErrorMessage(error)
      this.error = true
    },

    handleFinally () {
      this.$emit('load-end')
      this.loading = false
    }
  },

  watch: {
    value (newValue) {
      if (newValue.length || Object.keys(newValue).length) this.empty = false
      else this.empty = true
    }
  }
}
</script>
